<script setup>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import i18n from "@/i18n";
import ChangeDevices from "@/components/Common/ChangeDevices.vue";
import { useDeviceState } from "@/stores/deviceState";

const deviceState = useDeviceState();
const rtcId = ref("");
const counter = ref(0);
const token = ref(
  "Y9xD7GhHPFHJvwMYto0DZnSXo6O15av8RVyCuuiuldExXaKn03aIsAJj7tq0G9nhzZbI8pJmPwBjoLo0ILAJgvqk/0Ew8/BqTfSh8QPKtF239i7wMJXpYrq+ZI5cyduAoIZkMGuX7wEQlAI8gfTVZUIA1Z0/haU9XGCQwtF++/UuVq3xf1V8T4p/VMYPJL6cJaYW9HKWWPhERPhl3kKgfRkHkUTyxieWZ+OFRiSQPkEzMvjUuwXyjRNNo+qArDjQwc0S64X9q/cmJvlPxJmq/3PIBwCGf74CFA96gWBmMCZ+gWv4k7jzL8JlSDzKVhfixVcicD+n7Vr8Ie+So3ccLQ==",
);
const error = ref("");

const inQueue = ref(false);

const canGetRtcId = ref(false);

const ykbEnvOptions = [
  //test
  { title: "Test", value: "test" },
  //uat
  { title: "UAT", value: "uat" },
  //prelive
  { title: "Pre Live", value: "prelive" },
  //live
  { title: "Live", value: "live" },
];

const ykbEnv = ref("test");

function generateRtcId() {
  counter.value = 0;
  axios
    .get("/api/getnewrtcid")
    .then((response) => {
      rtcId.value = response.data;
      canGetRtcId.value = true;
    })
    .catch((error) => {
      console.log(error);
      error.value = "Error generating RTC ID" + error.toString();
      canGetRtcId.value = false;
    });
}

onMounted(() => {
  generateRtcId();
});

async function dial() {
  try {
    let apiUrl = window.CONFIG?.SIGNALING_URL || axios.defaults.baseURL;
    let socketProtocol = apiUrl.startsWith("https") ? "wss" : "ws";
    let host = new URL(apiUrl).host;

    let queueSocketUrl = socketProtocol + "://" + host + "/queue-socket/" + rtcId.value;

    let queueSocket = new WebSocket(queueSocketUrl);
    // wait for socket to open
    await new Promise((resolve) => {
      queueSocket.onopen = function () {
        resolve();
      };
    });

    queueSocket.onmessage = function (event) {
      console.log(event);
      let queueMessage = JSON.parse(event.data);
      if (queueMessage.messageType == "AgentConnected") {
        queueSocket.close();
        window.location.href = "/r/" + rtcId.value;
      }

      // CallDisconnected and SocketTimeout should reset the state add error message
      if (queueMessage.messageType == "CallDisconnected" || queueMessage.messageType == "SocketTimeout") {
        error.value = queueMessage.message;
        inQueue.value = false;
        queueSocket.close();
        generateRtcId();
      }
    };

    // on close reconnect to queue socket

    queueSocket.onclose = function () {
      console.log("Queue socket closed");
      if (inQueue.value) {
        console.log("inQueue is true Reconnecting to queue socket");
        queueSocket = new WebSocket(queueSocketUrl);
      }
    };

    error.value = "";
    let dialRequest = {
      RtcId: rtcId.value,
      VideoCallToken: token.value,
      VideoCallEnv: ykbEnv.value,
    };

    let dialResp = await axios.post("/api/dialex", dialRequest);

    if (!dialResp?.data?.InteractionId) {
      // Error
      error.value = dialResp.data.Message;
      return;
    }

    inQueue.value = true;
  } catch (err) {
    console.error(err);
    error.value = err.toString();
    inQueue.value = false;
  }
}

const buttonEnabled = computed(() => {
  return canGetRtcId.value && deviceState.canUseCamera;
});
</script>

<template>
  <v-sheet style="height: 100%" class="bg-deep-purple pa-12" rounded>
    <v-card class="mx-auto px-6 py-8" max-width="500">
      <v-card-title class="text-h5">{{ i18n.global.t("DemoTitle") }}</v-card-title>
      <v-card-text v-if="!inQueue">
        <v-form validate-on="submit" @submit.prevent="dial">
          <v-row>
            <v-alert :text="error" type="error" v-if="error"></v-alert>
            <v-col cols="12">
              <v-text-field
                density="compact"
                append-inner-icon="mdi-refresh"
                @click:append-inner="generateRtcId"
                v-model="rtcId"></v-text-field>
              <v-text-field density="compact" label="Ykb Token (Default test environment token)" v-model="token"></v-text-field>
              <v-select v-model="ykbEnv" :items="ykbEnvOptions" label="Ykb Token Servisi Environment"></v-select>
            </v-col>

            <v-col cols="12">
              <change-devices></change-devices>
            </v-col>

            <v-col cols="12" v-for="error in deviceState.errors" :key="error">
              <v-alert :text="error" type="error"></v-alert>
            </v-col>
            <v-col>
              <v-btn :disabled="!buttonEnabled" type="submit" color="green" block>
                {{ i18n.global.t("Dial") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text v-else>
        <v-row>
          <v-col cols="12">
            <v-alert icon="mdi-information-outline" :text="i18n.global.t('DemoInQueue')" type="info"></v-alert>
          </v-col>
          <v-col style="display: flex; justify-content: center">
            <v-progress-circular size="100" indeterminate="true"></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>
